import { FC, ReactNode, ButtonHTMLAttributes } from "react";

interface BFLButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  type?: "submit" | "button" | "reset";
  children: ReactNode;
}

const BFLButton: FC<BFLButtonProps> = ({
  className,
  type = "button",
  children,
  ...rest
}) => {
  return (
    <button
      type={type}
      className={`cursor-pointer ${className ?? ""}`}
      {...rest}
    >
      {children}
    </button>
  );
};

export default BFLButton;
